import * as z from "zod";

export const sendTestEmail = {
  name: "sendTestEmail" as const,
  input: z.object({
    teamId: z.string(),
    emailTemplateId: z.string(),
    recipients: z.array(z.string()),
  }),
  output: z.object({}),
};
